
import React, { useRef } from 'react';
import { ScrollAnimation } from './ScrollAnimation';
import { CifraClubPhoto } from './CifraClubPhoto';
import { GlobeAltIcon } from './icons/GlobeAltIcon';
import { AcademicCapIcon } from './icons/AcademicCapIcon';
import { UsersIcon } from './icons/UsersIcon';
import { useCountUp } from '../hooks/useCountUp';
import { useTranslation } from '../i18n/LanguageContext';

const icons = {
    academic: AcademicCapIcon,
    cifraclub: CifraClubPhoto,
    users: UsersIcon,
    globe: GlobeAltIcon,
};

const authorityItemValues = {
    students: 100,
    continents: 4,
};


const AnimatedStat: React.FC<{ value: number, prefix?: string }> = ({ value, prefix = "" }) => {
    const ref = useRef<HTMLSpanElement>(null);
    const count = useCountUp(ref, value, 2000);
    return <span ref={ref}>{prefix}{count}</span>;
};

export const AuthoritySection: React.FC = () => {
    const { t } = useTranslation();
    const authorityItems = t('authority.items') as { iconKey: keyof typeof icons, type: 'text' | 'number', valueKey?: keyof typeof authorityItemValues, title?: string, prefix?: string, description: string }[];

    return (
        <div className="w-full">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <ScrollAnimation animation="fadeIn" delay={600} threshold={0.2}>
                    <div className="py-8 bg-brand-secondary/30 backdrop-blur-sm rounded-xl border border-slate-700/30 shadow-lg">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-4">
                            {authorityItems.map((item, index) => {
                                const Icon = icons[item.iconKey];
                                return(
                                    <div key={index} className="flex flex-col items-center gap-3 text-center">
                                        <Icon className="w-10 h-10 text-brand-accent" />
                                        <div className="text-3xl lg:text-4xl font-serif font-bold text-brand-light h-10 flex items-center">
                                            {item.type === 'number' && item.valueKey ? (
                                                <AnimatedStat value={authorityItemValues[item.valueKey]} prefix={item.prefix} />
                                            ) : (
                                                item.title
                                            )}
                                        </div>
                                        <div className="text-sm font-medium text-slate-400 px-2">
                                            {item.description}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </ScrollAnimation>
            </div>
        </div>
    );
};
